import { type Translations } from './translations'

// Динамический импорт переводов из JSON файлов
export async function loadTranslations(languageCode: string): Promise<Translations> {
    try {
        // Динамически импортируем JSON файл с переводами
        const translations = await import(`./locales/${languageCode}.json`)
        return translations.default || translations
    } catch (error) {
        console.warn(`Failed to load translations for language: ${languageCode}`, error)
        // Возвращаем английские переводы по умолчанию
        const fallbackTranslations = await import('./locales/en.json')
        return fallbackTranslations.default || fallbackTranslations
    }
}

// Кеш для переводов
const translationsCache = new Map<string, Translations>()

// Функция для получения переводов с кешированием
export function getTranslationsSync(languageCode: string): Translations {
    // Проверяем кеш
    if (translationsCache.has(languageCode)) {
        return translationsCache.get(languageCode)!
    }

    // Если нет в кеше, используем статические импорты
    let translations: Translations
    
    switch (languageCode) {
        case 'ru':
            translations = require('./locales/ru.json')
            break
        case 'de':
            translations = require('./locales/de.json')
            break
        case 'en':
        default:
            translations = require('./locales/en.json')
            break
    }

    // Сохраняем в кеш
    translationsCache.set(languageCode, translations)
    return translations
}

// Функция для предзагрузки всех переводов
export async function preloadAllTranslations() {
    const languages = ['en', 'ru', 'de']
    
    await Promise.all(
        languages.map(async (lang) => {
            if (!translationsCache.has(lang)) {
                const translations = await loadTranslations(lang)
                translationsCache.set(lang, translations)
            }
        })
    )
}

// Функция для очистки кеша переводов (полезно для разработки)
export function clearTranslationsCache() {
    translationsCache.clear()
} 